import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=1bb689bc&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=ts&"
export * from "./news-list.vue?vue&type=script&lang=ts&"
import style0 from "./news-list.vue?vue&type=style&index=0&id=1bb689bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb689bc",
  null
  
)

export default component.exports